import React from 'react';
import './NavigationTabs.css';

const NavigationTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'tournament', label: 'Tournament' },
    { id: 'friends', label: 'Friends' },
    { id: 'concierge', label: 'Concierge' },
    { id: 'best', label: 'Best of the Best' }
  ];

  return (
    <div className="nav-tabs-container">
      <div className="nav-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`nav-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
        <div 
          className="nav-tab-indicator" 
          style={{ 
            left: `${tabs.findIndex(t => t.id === activeTab) * (100 / tabs.length)}%`,
            width: `${100 / tabs.length}%`
          }} 
        />
      </div>
    </div>
  );
};

export default NavigationTabs;
